import React, { Fragment, useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import Collapsible from 'react-collapsible';
import estilos from './FormularioFC09BeneficiarioComponent.module.css';
import { ArchivoComponent } from '../../ArchivosComponents/ArchivoComponent';
import ModalCamposObligatorios from '../../App/ModalCamposObligatorios';
import ModalEnviadoCorrectamente from '../../App/ModalEnviadoCorrectamente';
import {
    actualizarFC_09Estatus, actualizarFileFC_09, agregarFileFC_09, resetDataFC_09,
    actualizarFC_09Fecha
} from '../../../redux/DucksBeneficiario/FC_09Ducks';
import moment from 'moment'

const DocumentacionFC_09Component = (props) => {
    const dispatch = useDispatch()
    const modoCorreccion = useSelector(store => store.FC_09Solicitud.modoCorreccion)
    let data = useSelector(store => store.FC_09Solicitud.dataDocumentacion)
    const fechaHoy = moment().format('YYYY-MM-DD');
    const filesFC_09 = useSelector(store => store.FC_09Solicitud.files)
    const filesProductosFC_09 = useSelector(store => store.FC_09Solicitud.filesProductos)
    let filesMap = useSelector(store => store.FC_09Solicitud.filesMap)
    let filesProductosMap = useSelector(store => store.FC_09Solicitud.filesProductosMap)

    const [validacion, setvalidacion] = React.useState(false)
    const [texto, settexto] = React.useState('')
    const [envioCorrecto, setEnvioCorrecto] = React.useState(false)

    const [folio, setFolio] = React.useState('')

    const obtenerNumeroDeFiles = async () => {
        const countArchivos = await countFiles()
        const totalFilesGenerales = (files.filter(file => file.estatus === true)).length
        const totalFilesProductos = (filesProductos.filter(file => file.estatus === true)).length
        const contadorArchivo = totalFilesGenerales + totalFilesProductos

        if (countArchivos > contadorArchivo) {
            setvalidacion(true)
            settexto("")
        } else {
            let fecha = new Date(fechaHoy).toISOString()
            let solicitud = { fechasolicitud: fecha, idfc09_solicitudcertificado: data.idfc09_solicitudcertificado }
            await dispatch(actualizarFC_09Fecha(solicitud))
            setFolio(data.folio)
            const idSolicitud = data.idfc09_solicitudcertificado
            const estatusNuevo = 2
            const idCliente = null //Se necesita obtener del cliente, a traves del login 
            const tablaFC_09 = 4
            const tabla = tablaFC_09
            await dispatch(actualizarFC_09Estatus(
                { data: { tabla: tabla, idSolicitud: idSolicitud, estatus: estatusNuevo, idCliente: idCliente, folio: data.folio } }
            ))
            await dispatch(resetDataFC_09())
            setEnvioCorrecto(true)
        }
    }

    const countFiles = async () => {
        let count = 2
        for (const i in data.fc_09_anexoproducto) {
            const filesAnalisis = data.fc_09_anexoproducto[i].numeroanalisis.split(',')
            const filesCertificado = data.fc_09_anexoproducto[i].numerocertificado.split(',')
            count += filesAnalisis.length + filesCertificado.length + 1
        }
        return count
    }

    React.useEffect(() => {
        if (filesFC_09?.data) {
            let newFiles = []
            for (const file of filesFC_09.data) {
                const { ...newFile } = file
                newFiles.push(newFile)
            }
            setFile(newFiles)
        }

        if (filesProductosFC_09?.data) {
            let newFiles = []
            for (const file of filesProductosFC_09.data) {
                const { ...newFile } = file
                newFiles.push(newFile)
            }
            setFilesProductos(newFiles)
        }

    }, [data])


    /*React.useEffect(() => {
        return () => {
            dispatch(resetDataFC_09())
        }
    }, [])*/


    //FILES GENERALES
    const [files, setFile] = React.useState([])
    const handdleFile = async (objectFile) => {
        const data = {
            archivo: objectFile,
            ruta: 'FC_09/agregarNuevoFC_09AnexosArchivos'
        }
        const result = await dispatch(agregarFileFC_09(data))
        if (result.payload.data?.data) {
            objectFile.idAnexo = result.payload.data.data.idfc_09archivos
            objectFile.estatus = true
            setFile(prev => [...prev, objectFile])
            return true
        } else {
            return false
        }


    }

    const handdleRemovePrev = async (objectFile) => {

        if (objectFile) {
            const newFiles = files.map(file => {
                if (file.id === objectFile.id) {
                    file.file = objectFile.file
                    return (file)
                } else {
                    return (file)
                }
            })
            if (newFiles !== undefined) {
                const data = {
                    archivo: objectFile,
                    ruta: 'FC_09/actualizarFormatoFC09_AnexosArchivos'
                }
                const result = await dispatch(actualizarFileFC_09(data))
                if (result.payload === undefined) {
                    const data = {
                        archivo: objectFile,
                        ruta: 'FC_09/agregarNuevoFC_09AnexosArchivos'
                    }
                    result = await dispatch(agregarFileFC_09(data))
                }
                if (result.payload.data?.data) {
                    setFile(newFiles)
                    return true
                } else {
                    const newFiles = files.map(file => {
                        if (file.id === objectFile.id) {
                            file.estatus = false
                            return (file)
                        } else {
                            return (file)
                        }
                    })
                    setFile(newFiles)
                    return false
                }
            }
        }
    }

    // //FILES PRODUCTOS
    //handdleFile: , handdleRemovePrev: , files:  }}
    const [filesProductos, setFilesProductos] = React.useState([])
    const handdleFileProducto = async (objectFile) => {
        const data = {
            archivo: objectFile,
            ruta: 'FC_09/agregarNuevoFC_09AnexosArchivosProducto'
        }
        const result = await dispatch(agregarFileFC_09(data))
        if (result.payload.data?.data) {
            objectFile.idAnexo = result.payload.data.data.idfc_09archivoproducto
            objectFile.estatus = true
            setFilesProductos(prev => [...prev, objectFile])
            return true
        } else {
            return false
        }

    }

    const handdleRemoveProductoPrev = async (objectFile) => {
        if (objectFile) {
            const newFiles = filesProductos.map(file => {
                if (file.id === objectFile.id) {
                    file.file = objectFile.file
                    return (file)
                } else {
                    return (file)
                }
            })
            if (newFiles !== undefined) {
                const data = {
                    archivo: objectFile,
                    ruta: 'FC_09/actualizarFormatoFC09_AnexosArchivosProducto'
                }
                const result = await dispatch(actualizarFileFC_09(data))
                if (result.payload === undefined) {
                    const data = {
                        archivo: objectFile,
                        ruta: 'FC_09/agregarNuevoFC_09AnexosArchivosProducto'
                    }
                    result = await dispatch(agregarFileFC_09(data))
                }
                if (result.payload.data?.data) {
                    setFilesProductos(newFiles)
                    return true
                } else {
                    const newFiles = filesProductos.map(file => {
                        if (file.id === objectFile.id) {
                            file.estatus = false
                            return (file)
                        } else {
                            return (file)
                        }
                    })
                    setFilesProductos(newFiles)
                    return false
                }
            }
        }
    }


    const FilesGenerales = () => {
        return (
            <div>
                <Collapsible trigger="Documentación general" className='mb-3'>
                    <div className={`mb-3 ${estilos.divSoloBorderDocsNaranja}`}>
                        <ArchivoComponent api={{ handdleFile, handdleRemovePrev, files }} id={'DGOC'} tabla={"FC_09_anexos"}
                            filesMap={filesMap}
                            textLabel={`Orden de compra: `} textoTooltip='Del importador o invitación a la feria o exposición en el extranjero.'
                            idAnexoFK={data.idfc09_solicitudcertificado} />
                        <ArchivoComponent api={{ handdleFile, handdleRemovePrev, files }} id={'DGFP'} tabla={"FC_09_anexos"}
                            filesMap={filesMap}
                            textLabel={`Factura o proforma: `} textoTooltip='En caso de que el producto se exporte con fines de promoción, entregar factura sin valor comercial.'
                            idAnexoFK={data.idfc09_solicitudcertificado} />

                    </div>
                </Collapsible>
            </div>
        )
    }
    const FilesProductos = () => {
        let file = []
        let certificadoAnalisis = []
        return (
            <div>
                <Collapsible trigger="Documentación de productos" className='mb-3'>
                    {data.fc_09_anexoproducto?.map((anexo, index) => (

                        <div className={`mb-3 ${estilos.divSoloBorderDocsNaranja}`}>
                            <label className='text-center'>Producto:{Number(index) + Number(1)}</label>
                            {file = anexo.numeroanalisis.split(',')}
                            {certificadoAnalisis = anexo.numerocertificado.split(',')}
                            {file.map((analisis, i) => (
                                <ArchivoComponent api={{ handdleFile: handdleFileProducto, handdleRemovePrev: handdleRemoveProductoPrev, files: filesProductos }} tabla={"FC_09_anexos"}
                                    textLabel={`Análisis de laboratorio ${analisis} :`} idAnexoFK={anexo.idfc09_anexoproducto} id={`DPAL${index}${i}`} textoTooltip=''
                                    filesMap={filesProductosMap}
                                />
                            ))}
                            {certificadoAnalisis.map((certificado, i) => (
                                <ArchivoComponent api={{ handdleFile: handdleFileProducto, handdleRemovePrev: handdleRemoveProductoPrev, files: filesProductos }} tabla={"FC_09_anexos"}
                                    textLabel={`Certificado NOM de producto a granel ${certificado}: `} idAnexoFK={anexo.idfc09_anexoproducto} id={`DPCA${index}${i}`} textoTooltip=''
                                    filesMap={filesProductosMap}
                                />
                            ))}
                            <ArchivoComponent api={{ handdleFile: handdleFileProducto, handdleRemovePrev: handdleRemoveProductoPrev, files: filesProductos }} tabla={"FC_09_anexos"}
                                textLabel={`Etiqueta aprobada: `} idAnexoFK={anexo.idfc09_anexoproducto} id={`DPEP${index}`} textoTooltip=''
                                filesMap={filesProductosMap}
                            />
                        </div>
                    ))}

                </Collapsible>
            </div>
        )
    }

    const resetValores = (objectProducto) => {
        setvalidacion(objectProducto.validacion)
    }
    return (
        <Fragment>
            <div className='row container ms-5'>
                <div className='ms-5'>
                    {FilesGenerales()}
                    {FilesProductos()}
                </div>
                <br />
                {
                    !modoCorreccion &&
                    <div className="text-center ms-5">
                        <button type="submit" onClick={() => obtenerNumeroDeFiles()}
                            className={`btn ${estilos.botonNaranjaRedondo}`}>Finalizar Envio</button>
                    </div>
                }

            </div>
            {envioCorrecto && <ModalEnviadoCorrectamente folioSolicitud={folio}></ModalEnviadoCorrectamente>}
            {validacion && <ModalCamposObligatorios texto={texto} api={{ resetValores }}></ModalCamposObligatorios>}
        </Fragment>
    )
};

export default withRouter(DocumentacionFC_09Component)
